import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit'
import axios from 'axios'
const currentToken = localStorage.getItem('humblebeeAuthToken')
const initialState = {
  singleProject: {},
  loading: true,
  error: '',
  message: '',
}

export const resetMessageinEditProject = createAction(
  'resetMessageinEditProject'
)
export const resetErrorinEditProject = createAction('resetErrorinEditProject')

export const editSingleProject = createAsyncThunk(
  'editSingleProject',
  async ({ editId, projectData }, { rejectWithValue }) => {
    console.log('formdata', projectData)
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_HUMBLEBEE_API_URL}/projects/${editId}`,
        projectData,
        {
          headers: {
            authorization: `Bearer ${currentToken}`,
            Accept: '/',
          },
        }
      )

      return res.data
    } catch (error) {
      console.log(error)
      //@ts-ignore
      return rejectWithValue(error.response.data)
    }
  }
)

const editSingleProjectSlice = createSlice({
  name: 'editSingleProject',
  initialState,
  reducers: {},
  extraReducers: {
    //@ts-ignore
    [editSingleProject.pending]: (state, action) => {
      state.loading = true
    },
    //@ts-ignore
    [editSingleProject.fulfilled]: (
      //@ts-ignore
      state,
      //@ts-ignore
      { payload: { error, singleProject, message } }
    ) => {
      state.loading = false
      if (error) {
        state.error = error
      } else {
        state.message = message
      }
    },
    //@ts-ignore
    [editSingleProject.rejected]: (
      state,
      //@ts-ignore
      { payload: { message, error } }
    ) => {
      state.error = error
      state.message = message
    },
    [resetErrorinEditProject]: state => {
      state.error = ''
    },
    [resetMessageinEditProject]: state => {
      state.message = ''
    },
  },
})

export default editSingleProjectSlice.reducer
